import * as React from "react"
import {useContext} from "react"
import {Header} from "nhsuk-react-components"
import {AppContext} from "../index"
import {isSandbox} from "../services/environment"
import SessionTimer from "./sessionTimer"
import styled from "styled-components"

interface PageHeaderProps {
  loggedIn: boolean
}

const EndNavItem = styled(Header.NavigationItem)`
  margin-left: auto;
`

export const PageHeader: React.FC<PageHeaderProps> = ({loggedIn}) => {
  const {baseUrl, environment} = useContext(AppContext)
  return (
    <Header
      logo={{href: baseUrl}}
      service={{
        href: loggedIn ? `${baseUrl}config` : baseUrl,
        text: "EPSAT - Electronic Prescription Service API Tool"
      }}
    >
      {loggedIn && (
        <Header.Navigation className="nhsuk-width-container">
          <Header.NavigationItem href={baseUrl}>Home</Header.NavigationItem>
          <Header.NavigationItem href={`${baseUrl}my-prescriptions`}>My Prescriptions</Header.NavigationItem>
          <Header.NavigationItem href={`${baseUrl}config`}>Config</Header.NavigationItem>
          {!isSandbox(environment) && <Header.NavigationItem href={`${baseUrl}logout`}>Logout</Header.NavigationItem>}
          <EndNavItem><SessionTimer /></EndNavItem>
        </Header.Navigation>
      )}
    </Header>
  )
}
